module.exports = __webpack_public_path__ + "static/media/ic-location-gray-24-px.6787b058.svg";